import type { Chain } from "viem";
import type { Address, Hash } from "viem";

export function explorerTxUrl(chain: Chain | undefined, hash: Hash | undefined): string | undefined {
  if (!chain || !hash) return;
  const base = chain.blockExplorers?.default?.url;
  if (!base) return;
  return `${base}/tx/${hash}`;
}

export function explorerAddressUrl(chain: Chain | undefined, address: Address | undefined): string | undefined {
  if (!chain || !address) return;
  const base = chain.blockExplorers?.default?.url;
  if (!base) return;
  return `${base}/address/${address}`;
}


